import React, { useState } from 'react';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import { Link } from 'react-router-dom';

const PricingPage = () => {
  // State to manage the toggle between monthly and yearly pricing
  const [isYearly, setIsYearly] = useState(false);

  // Function to handle toggle change
  const togglePricing = () => {
    setIsYearly(!isYearly);
  };

  // Pricing data
  const pricingPlans = [
    {
      title: "Free",
      monthlyPrice: "$0",
      yearlyPrice: "$0",
      features: [
        "1,000 impressions/month (est 5K pageviews)",
        "Unlimited popups",
        "Unlimited autoresponders",
        "All features",
        "Chat & email support",
        { text: "AI Chatbot Integration", disabled: true },
      ],
    },
    {
      title: "Growth",
      monthlyPrice: "$7.99",
      yearlyPrice: "$71.99", // Example yearly price
      features: [
        { text: "20,000+ PNG & SVG graphics", disabled: true },
        "Access to 100 million stock images",
        "Upload custom icons and fonts",
        "Unlimited Sharing",
        "Upload graphics & video in up to 4k",
        "Unlimited Projects",
      ],
    },
    {
      title: "Professional",
      monthlyPrice: "$34.99",
      yearlyPrice: "$314.99", // Example yearly price
      features: [
        "100,000 impressions/month (est 500K pageviews)",
        "Access to 100 million stock images",
        { text: "All features", disabled: true },
        "Unlimited popups",
        "Unlimited autoresponders",
        "Unlimited Projects",
      ],
      featured: true, // Mark this plan as featured
    },
    {
      title: "Premium",
      monthlyPrice: "$69.99",
      yearlyPrice: "$629.99", // Example yearly price
      features: [
        "200,000 impressions/month (est 1M pageviews)",
        "Unlimited popups",
        "Unlimited autoresponders",
        "Unlimited Sharing",
        "Upload graphics & video in up to 4k",
        "Chat & email support",
      ],
    },
  ];

  return (
    <div>
      {/* Header Start */}
      <Header/>
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Pricing</h4>
          <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
            <li className="breadcrumb-item active text-primary">Pricing</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* Pricing Section Start */}
      <div className="container-fluid py-5">
        <div className="epic-x-pricing-container">
          <div className="text-center">
            <h2 className="epic-x-heading">Streamline your teamwork. Start free.</h2>
            <p className="epic-x-subheading">Choose the perfect plan for your business needs</p>
          </div>
          <div className="epic-x-toggle-container">
            <span className="epic-x-toggle-label">Pay Monthly</span>
            <label className="epic-x-switch">
              <input type="checkbox" id="toggle" checked={isYearly} onChange={togglePricing} />
              <span className="epic-x-slider epic-x-round"></span>
            </label>
            <span className="epic-x-toggle-label">Pay Yearly</span>
          </div>
          <div className="epic-x-pricing-plans">
            {pricingPlans.map((plan, index) => (
              <div
                key={index}
                className={`epic-x-plan ${plan.featured ? "epic-x-featured" : ""}`}
              >
                <h3 className="epic-x-plan-title">{plan.title}</h3>
                <p className="epic-x-price">
                  {isYearly ? plan.yearlyPrice : plan.monthlyPrice}{" "}
                  <span className="epic-x-price-duration">/ {isYearly ? "Year" : "Month"}</span>
                </p>
                <button className="epic-x-button">Get Started Now</button>
                <ul className="epic-x-features">
                  {plan.features.map((feature, i) => (
                    <li
                      key={i}
                      className={`epic-x-feature ${feature.disabled ? "epic-x-disabled" : ""}`}
                    >
                      {typeof feature === "string" ? feature : feature.text}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Pricing Section End */}
      <Footer/>
    </div>
  );
};

export default PricingPage;